// Lib
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { isMobile, isKiteUser } = {}) => ({
    root: {
      border: !isMobile ? '1px dashed #C6CAC6' : 'none',
      borderRadius: 6,
      padding: 20,
      marginBottom: 10,
      marginTop: theme.spacing(3),
      textAlign: 'center',
      width: '100%',
      [theme.breakpoints.down('lg')]: {
        padding: 0,
        marginTop: 0,
      },
      [theme.breakpoints.down('md')]: {
        paddingTop: theme.spacing(3),
      },
    },
    title: {
      [theme.breakpoints.down('md')]: {
        fontSize: '16px !important',
      },
    },
    button: {
      backgroundColor: theme.palette.lightGrey,
      color: isKiteUser ? theme.palette.primary1 : theme.palette.primary2,
      display: 'initial',
      marginBottom: theme.spacing(1.5),
      marginTop: theme.spacing(3.5),
      maxHeight: 44,
      padding: '8px 32px',
      '&:hover': {
        backgroundColor: `${theme.palette.lightGrey} !important`,
      },
    },
    spinner: {
      marginTop: theme.spacing(1),
    },
  }),
);
